import { getIconClassName } from '@uifabric/styling/lib/index';
import { getRTL } from '@uifabric/utilities';

const styles = require('./getAdjustedIconClassName.scss');
const classNames = require('classnames/bind').bind(styles);

const IconsToFlipInRTL: { [key: string]: boolean } = {
    ChevronRight: true,
    List: true,
    Back: true,
    Forward: true,
    Send: true,
    ResponsesMenu: true,
};

export default function getAdjustedIconClassName(name: string): string {
    let style = getIconClassName(name);
    const shouldFlip = IconsToFlipInRTL[name];
    style = classNames(style, getRTL() && !!shouldFlip ? styles.rtlIcon : null);
    return style;
}
